import { Injectable } from '@angular/core';
import { Person } from "../../interfaces/person";
import { BehaviorSubject, Subscription } from "rxjs";
import { Apollo } from "apollo-angular";
import { SEARCH_ACTIVE_EMPLOYEES } from "./graphql/employee-search";

@Injectable({
  providedIn: 'root'
})
export class EmployeeSearchService {

  private _people: Person[] = [];
  private people = new BehaviorSubject(this._people);
  public people$ = this.people.asObservable();

  private _loading = false;
  private loading = new BehaviorSubject(this._loading);
  public loading$ = this.loading.asObservable();

  constructor(public apollo: Apollo) { }


  private _setPeople(people: Person[]){
    this._people = people;
    this.people.next(this._people);
  }
  private _setLoading(loading: boolean){
    this._loading = loading;
    this.loading.next(this._loading);
  }

  public searchPeople(name:string){
    let sub: Subscription;
    this._setLoading(true);
    sub = this.apollo
        .query({query:SEARCH_ACTIVE_EMPLOYEES, variables:{name: `%${name}%`}})
        .subscribe(({data})=>{
          this._setLoading(false);
          if(data?.search_active_employees) {
            this._setPeople(data.search_active_employees);
          }
          sub?.unsubscribe();
        });
  }
}
